// 会员路由
const name = '开发'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/agents',
  component: Layout,
  children: [
    {
      path: 'applications',
      name: `代理商列表`,
      meta: {
        hidemenu: true,
        routeId: 'agent-id'
      },
      component: () => import('@/view/agent/list'),
      children: [
        {
          path: 'editor',
          meta: {
            hidemenu: true
          },
          component: () => import('@/view/agent/editor')
        },
        {
          path: 'commission',
          meta: {
            hidemenu: true
          },
          component: () => import('@/view/agent/commission')
        }
      ]
    }
  ]
}
